(function () {
  if (window.__hollyAddToCartSyncBound) return;
  window.__hollyAddToCartSyncBound = true;

  var locked = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getCart() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function notifySubscribers() {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      // No cartData passed: subscribers (samples, datalayer, etc.) refetch /cart.js.
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'holly-app-addtocart' });
    }
  }

  // Fill the cart sections in place, then open the drawer. We intentionally do
  // NOT call cart.renderContents() (the theme's combined render+open) because
  // its internal timing is what produced the empty-drawer flash — here we paint
  // the content synchronously and only open afterwards.
  function renderWithSections(cart, sections) {
    cart.getSectionsToRender().forEach(function (section) {
      var id = section.section || section.id;
      var html = sections[id];
      if (!html) return;

      var target = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!target) return;

      var parsed = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(section.selector || '.shopify-section');
      if (parsed) target.innerHTML = parsed.innerHTML;
    });

    // Drop the empty state and re-bind the overlay close button — replacing
    // #CartDrawer's innerHTML above discards the node the constructor bound to.
    if (cart.classList) cart.classList.remove('is-empty');
    var inner = cart.querySelector ? cart.querySelector('.drawer__inner') : null;
    if (inner) inner.classList.remove('is-empty');
    var overlay = cart.querySelector ? cart.querySelector('#CartDrawer-Overlay') : null;
    if (overlay && typeof cart.close === 'function') {
      overlay.addEventListener('click', cart.close.bind(cart));
    }

    notifySubscribers();

    // Content is in the DOM now — safe to reveal the drawer without it flashing
    // empty.
    if (typeof cart.open === 'function') cart.open();
  }

  function handleAdd(event) {
    if (locked) return;
    // Guard against the same action being dispatched on both document and window.
    locked = true;
    setTimeout(function () {
      locked = false;
    }, 50);

    var response = (event && event.detail) || {};

    // Ignore add errors surfaced by the app (Shopify uses a numeric status on error).
    if (response && response.status && response.status !== 200) return;

    var cart = getCart();
    if (!cart || typeof cart.getSectionsToRender !== 'function') {
      // No live cart UI to update — fall back to a reload so the cart is correct.
      window.location.reload();
      return;
    }

    // If the app already provided rendered sections, use them directly.
    if (response.sections) {
      renderWithSections(cart, response.sections);
      return;
    }

    // Otherwise fetch exactly the sections the cart needs.
    var ids = cart.getSectionsToRender().map(function (s) {
      return s.section || s.id;
    });

    fetch(root() + '?sections=' + encodeURIComponent(ids.join(',')), {
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        renderWithSections(cart, sections);
      })
      .catch(function () {
        // Last resort: reload so the cart never silently misses the item.
        window.location.reload();
      });
  }

  // The app may dispatch on document or window; listen on both.
  document.addEventListener('holly-app-addtocart', handleAdd);
  window.addEventListener('holly-app-addtocart', handleAdd);
})();
/* custom code end */
